<template>
    <a
        href="#"
        class="dropdown-toggle nk-quick-nav-icon"
        data-bs-toggle="dropdown"
    >
        <div
            v-bind:class="
                inbox.length == 0 ? '' : 'icon-status icon-status-info'
            "
        >
            <em class="icon ni ni-inbox-fill"></em>
        </div>
    </a>
    <div
        class="dropdown-menu dropdown-menu-xl dropdown-menu-right dropdown-menu-s1"
    >
        <div class="dropdown-head">
            <span class="sub-title nk-dropdown-title"
                >My Inbox
                <span class="badge rounded-pill bg-primary">{{
                    inbox.length ?? 0
                }}</span></span
            >
            <a href="javascript:void(0)" @click="readAll">Mark All as Read</a>
        </div>
        <div class="dropdown-body">
            <div class="nk-notification">
                <a
                    class="nk-notification-item dropdown-inner"
                    v-for="(item, index) in inbox"
                    :key="index"
                    :href="'/my-inbox/?id=' + item.id"
                >
                    <div class="nk-notification-icon">
                        <em v-bind:class="iconClass(item.folder.name)"></em>
                    </div>
                    <div class="nk-notification-content">
                        <div class="nk-notification-text">
                            {{ item.message.subject + ' ' + item.message.subject_type + ' ' + (item.message.sender.title ? ' : ' + item.message.sender.title : '')}}
                        </div>
                        <div class="nk-notification-time">
                            {{ frontEndDateFormat(item.created_at) }}
                        </div>
                    </div>
                </a>
            </div>
            <div class="dropdown-foot center">
                <a href="/my-inbox">Go to My Inbox</a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    name: "Inbox",
    methods: {
        frontEndDateFormat: function (date) {
            return moment(date).fromNow();
        },
        iconClass: function (type) {
            switch (type) {
                case "Mail":
                    return "icon icon-circle bg-info-dim ni ni-mail";
                case "Approval":
                    return "icon icon-circle bg-warning-dim ni ni-check-circle-cut";
                case "Internal memo":
                    return "icon icon-circle bg-warning-dim ni ni-note-add";
                case "Disposition":
                    return "icon icon-circle bg-warning-dim ni ni-circle-cut";
                default:
                    return "icon icon-circle bg-warning-dim ni ni-folder";
            }
        },
        readAll(){
            axios.post("/my-inbox/recipients/read-all")
            .then((response) => {
                // console.log(response);
                this.loadNotification()
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        loadNotification(){
            axios
            .get("/my-inbox/recipients/unread")
            .then((response) => {
                // console.log(response);
                this.inbox = response.data.data;
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    },
    data() {
        return {
            inbox: [],
        };
    },

    created() {
        this.loadNotification()
    },
};
</script>

<style scoped></style>
